import { BaseTooltipAction, TooltipState } from '../types';

type DonationSettingsTooltipAction = BaseTooltipAction;

export function donationSettingsSaveTooltipReducer(
    state: TooltipState,
    action: DonationSettingsTooltipAction,
): TooltipState {
    switch (action) {
        case 'error':
            return {
                tooltipVisible: true,
                tooltipTheme: 'error',
                tooltipLabel: 'Произошла ошибка',
            };
        case 'ok':
            return {
                tooltipVisible: true,
                tooltipTheme: 'normal',
                tooltipLabel: 'Сохранено',
            };
        case 'clear':
            return {
                tooltipVisible: false,
            };
    }
}

export function donationSettingsDeleteTooltipReducer(
    state: TooltipState,
    action: DonationSettingsTooltipAction,
): TooltipState {
    switch (action) {
        case 'error':
            return {
                tooltipVisible: true,
                tooltipTheme: 'error',
                tooltipLabel: 'Произошла ошибка',
            };
        case 'ok':
            return {
                tooltipVisible: true,
                tooltipTheme: 'normal',
                tooltipLabel: 'Отключено',
            };
        case 'clear':
            return {
                tooltipVisible: false,
            };
    }
}
